import * as BABYLON from "babylonjs"
import { Player } from "../classes/player"
import { DialPicker } from "../components/3DUIElements/DialPicker"
import { Global } from "../classes/global"

var catDrag = false
var pickedMesh: BABYLON.Nullable<BABYLON.AbstractMesh>

export class XRPointerInteractions {
	static enable(
		scene: BABYLON.Scene,
		xr: BABYLON.WebXRDefaultExperience
	): void {
		scene.onPointerDown = function (evt, pickResult) {
			if (pickResult.pickedMesh != null) {
				//Player.xrInteraction(pickResult.pickedMesh)
				pickedMesh = pickResult.pickedMesh
				if (pickResult.pickedMesh.name.startsWith("UI_dialPicker")) {
					Global.dialInteraction = true
					Global.dialHit = pickResult.hit
					Global.dialPickedPoint = pickResult.pickedPoint
				}

				//cat
				if (pickResult.pickedMesh.name == "body") {
					catDrag = true
				}
			}
		}

		scene.onPointerMove = function (evt, pickResult) {
			//Conditions for pannel dragability
			if (
				pickResult.pickedMesh != null &&
				pickResult.pickedMesh.parent != null
			) {
				if (
					pickResult.pickedMesh!.parent!.name == "UI_parent" ||
					pickResult.pickedMesh!.parent!.name == "UI_parent1"
				) {
					Global.canDrag = false
				} else {
					Global.canDrag = true
				}
			} else if (
				pickResult.pickedMesh != null &&
				pickResult.pickedMesh!.parent == null
			) {
				Global.canDrag = true
			}

			//Conditions for Dial
			if (Global.dialInteraction) {
				Global.dialHit = pickResult.hit
				Global.dialPickedPoint = pickResult.pickedPoint
			}
			// Condition for cat
			//if (catDrag) Player.xrInteraction(pickedMesh, Global.xr_right.position)
		}
		scene.onPointerUp = function (evt, pickResult) {
			catDrag = false
			Global.dialInteraction = false
		}
		var sixDofDragBehavior = new BABYLON.PointerDragBehavior()
		sixDofDragBehavior.moveAttached = false
		Player.mesh!.addBehavior(sixDofDragBehavior)
		sixDofDragBehavior.onDragObservable.add((event) => {
			const deltaX = event.delta.x * 7
			const deltaY = event.delta.y
			Player.mesh!.rotate(BABYLON.Axis.Y, -deltaX, BABYLON.Space.WORLD)
			Player.mesh!.position.y += deltaY
		})
	}

	static pannelsRotation(scene: BABYLON.Scene): void {
		scene.onBeforeRenderObservable.add(() => {
			var parentPanelMesh = scene.getMeshByID("UI_parent")
			var parentPanelMesh1 = scene.getMeshByID("UI_parent1")
			if (parentPanelMesh != null && parentPanelMesh1 != null) {
				parentPanelMesh!.rotationQuaternion = BABYLON.Quaternion.Identity()
				parentPanelMesh1!.rotationQuaternion = BABYLON.Quaternion.Identity()
			}
		})
	}

	static pannelsAnchor(): void {
		var parentPanelMesh = Global.scene.getMeshByID("UI_parent")
		var parentPanelMesh1 = Global.scene.getMeshByID("UI_parent1")
		if (
			parentPanelMesh != null &&
			parentPanelMesh1 != null &&
			Global.xr.baseExperience.camera != null
		) {
			if (Global.anchored) {
				parentPanelMesh.parent = Global.xr.baseExperience.camera
				parentPanelMesh.position = new BABYLON.Vector3(0.4, 0, 1)
				parentPanelMesh.removeBehavior(Global.parentPlaneDragBehaviour)
				parentPanelMesh1.parent = Global.xr.baseExperience.camera
				parentPanelMesh1.position = new BABYLON.Vector3(-0.4, 0, 1)
				parentPanelMesh1.removeBehavior(Global.parentPlaneDragBehaviour1)
				Global.anchored = false
			} else {
				parentPanelMesh.parent = null
				parentPanelMesh.position = new BABYLON.Vector3(0.4, 1.3, 1.3)
				parentPanelMesh.addBehavior(Global.parentPlaneDragBehaviour)
				parentPanelMesh1.parent = null
				parentPanelMesh1.position = new BABYLON.Vector3(-0.4, 1.3, 1.3)
				parentPanelMesh1.addBehavior(Global.parentPlaneDragBehaviour1)
				Global.anchored = true

				Global.parentPlaneDragBehaviour.onDragStartObservable.add(() => {
					if (Global.canDrag) {
						//canDrag = false
						Global.parentPlaneBlock.thickness = 6 // Border thickness
						Global.parentPlaneBlock.color = Global.parentBlockHighlightColour // Border color
						Global.parentPlaneDragBehaviour.disableMovement = false
					}
				})

				Global.parentPlaneDragBehaviour1.onDragStartObservable.add(() => {
					if (Global.canDrag) {
						//canDrag = false
						Global.parentPlaneBlock1.thickness = 6 // Border thickness
						Global.parentPlaneBlock1.color = Global.parentBlockHighlightColour // Border color
						Global.parentPlaneDragBehaviour1.disableMovement = false
					}
				})

				Global.parentPlaneDragBehaviour.onDragEndObservable.add(() => {
					Global.parentPlaneBlock.thickness = 0 // Reset thickness to remove the border
					Global.parentPlaneDragBehaviour.disableMovement = true
				})

				Global.parentPlaneDragBehaviour1.onDragEndObservable.add(() => {
					Global.parentPlaneBlock1.thickness = 0 // Reset thickness to remove the border
					Global.parentPlaneDragBehaviour1.disableMovement = true
				})
			}
		}
	}
}
